module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aleg50-8c9780fad42c5d2a1dddcc37e217f2ca.jpg";